export default __webpack_public_path__ + "static/media/watch.b98af0e5.svg";